import React, { useState, useEffect } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  Checkbox,
  Button,
  Switch,
  Grid,
  Box,
  Typography,
  Paper,
  AppBar,
  Toolbar,
  OutlinedInput,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
// import ReactFlagsSelect from "react-flags-select";
// import CountryJson from '../../../utils/CountryCodes.json';
import { isValidEmail, isValidPhoneNumber } from '../../../utils/helper.jsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { EntityFormFields } from '../../../interfaces/Entity.interface.ts';
import { EntityActions } from '../../../Services/_actions/Entity/entity.actions.ts';
import ClearIcon from '@mui/icons-material/Clear';
import { ConstantActions } from '../../../Services/_actions/constant.actions.js';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import {
  BLOCKED_EXTENSIONS,
  WHATSAPP_ALLOWED_MIME,
  WHATSAPP_LIMITS,
} from '../../Whatsapp/Template/template.constant.js';

const CreateEditFormData = () => {
  const { entityFormId } = useParams();
  const { uuid } = useParams();
  const actions = EntityActions();
  const constantActions = ConstantActions();
  const { state } = useLocation();
  const [entityRowData, setEntityRowData] = useState<any>({});
  // const [selectedParentEntity, setSelectedParentEntity] = useState < any > (null);
  // const [nestedEntityDataDropdown, setNestedEntityDataDropdown] = useState < any > ([]);
  const [selectedNestedParentEntity, setSelectedNestedParentEntity] = useState<any>({});
  const [formData, setFormData] = useState<(EntityFormFields | any)[]>([]);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { showSnackBar } = useSnackBar();
  const [errors, setErrors] = useState({});
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const [showHideFileUpload, setShowHideFileUpload] = useState({});
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const validateFormData = (data: any) => {
    let validationErrors: any = {};
    data?.map((item: any) => {
      switch (item?.type) {
        case 'email':
          if (item?.type === 'email' && isValidEmail(item?.value)) {
            delete validationErrors[item?.name];
          } else {
            validationErrors[item?.name] = 'Please Enter a valid Email';
          }
          break;
        case 'phone':
          if (isValidPhoneNumber(item?.value)) {
            delete validationErrors[item?.name];
          } else {
            validationErrors[item?.name] = 'Please Enter a valid Number';
          }
          break;
      }
    });
    setErrors(validationErrors);
    return validationErrors;
  };
  const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
    if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
    if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
    if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
    if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
    return null;
  };
  const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);
  const fileHelperTextMap: Record<string, string> = {
    image: 'Allowed: JPG, PNG • Max 5 MB',
    video: 'Allowed: MP4, MOV • Max 50 MB',
    document: 'Allowed: PDF, DOCX • Max 10 MB',
  };
  const handleChange = (event: any, index: any, field: any) => {
    const { name, value, type, checked, files, images } = event.target;
    switch (field?.type) {
      case 'text':
      case 'textArea':
      case 'number':
      case 'email':
      case 'dropdown':
      case 'radio':
      case 'date':
      case 'password':
        setFormData((prevItems: any) => {
          const updatedItems = [...prevItems];
          updatedItems[index] = { ...updatedItems[index], value: value };
          return updatedItems;
        });
        break;
      case 'phone':
        let isInteger = Number.isInteger(Number(value));
        if (isInteger && value.length < 13) {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            updatedItems[index] = { ...updatedItems[index], value: value };
            return updatedItems;
          });
          let obj: any = { ...errors };
          delete obj[field?.name];
          setErrors(obj);
        } else if (value.length < 13) {
          let obj: any = { ...errors };
          obj[field?.name] = 'Please Enter a valid number';
          setErrors(obj);
        }
        break;
      case 'checkbox':
        if (checked) {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            updatedItems[index] = {
              ...updatedItems[index],
              value: [...(updatedItems[index]?.value || []), value],
            };
            return updatedItems;
          });
        } else {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            const updateValue = updatedItems[index]['value']?.filter((item: any) => item !== value);
            updatedItems[index] = { ...updatedItems[index], value: updateValue };
            return updatedItems;
          });
        }
        break;
      // case 'file':
      case 'image':
      case 'video':
      case 'document':
        if (files && files[0]) {
          const file = files[0];
          if (!file) return;
          const fileName = file?.name?.toLowerCase();
          const ext = fileName.split('.').pop();
          if (BLOCKED_EXTENSIONS.has(ext)) {
            showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
            event.target.value = '';
            return;
          }
          const typeGroup = inferDocType(file.type);
          if (!typeGroup) {
            showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
            event.target.value = '';
            return;
          }

          const limit = WHATSAPP_LIMITS[typeGroup];
          if (file.size > limit) {
            showSnackBar(
              `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file?.size)} MB.`,
              'error'
            );
            event.target.value = '';
            return;
          }
          const allowedExtensions: { [key: string]: string[] } = {
            // file: ["pdf", "doc", "docx", "txt", "xls", "xlsx"],
            image: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
            video: [
              'mp4',
              'mov',
              'avi',
              'wmv',
              'flv',
              'mkv',
              'webm',
              'ogg',
              'quicktime',
              'msvideo',
              'x-ms-wmv',
              'x-ms-wmv',
            ],
            document: ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'],
          };

          const fileExtension = file?.name?.split('.').pop()?.toLowerCase();
          if (fileExtension && allowedExtensions[field.type]?.includes(fileExtension)) {
            setFormData((prevItems: any) => {
              const updatedItems = [...prevItems];
              updatedItems[index] = {
                ...updatedItems[index],
                value: file.name,
                fileObj: file,
                // newFile: true,
              };
              return updatedItems;
            });
          } else {
            showSnackBar(
              `Invalid file type for ${field.type}. Allowed: ${allowedExtensions[field.type].join(', ')}`,
              'error'
            );
            event.target.value = null;
            let obj: any = { ...errors };
            obj[field?.name] =
              `Invalid ${field.type} file type. Allowed: ${allowedExtensions[field.type].join(', ')}`;
            setErrors(obj);
          }
        } else {
          setFormData((prevItems: any) => {
            const updatedItems = [...prevItems];
            updatedItems[index] = { ...updatedItems[index], value: value };
            return updatedItems;
          });
        }
    }
  };

  const entityId: any = uuid !== 'create' ? state?.row?._id : null;

  const uploadFile = async (file: File): Promise<{ link?: string; name?: string }> => {
    try {
      if (file) {
        // const myFilename = `${Date.now().toString()}_${file.name.replace(/ /g, '_')}`;
        // const updatedFile = new File([file], myFilename, { type: file.type });
        const formData = new FormData();
        formData.append('file', file);
        const resp = await constantActions.uploadFileS3Bucket(formData);
        if (resp?.status === 200 && resp?.data?.data) {
          return { link: resp?.data?.data?.url ?? '', name: resp?.data?.data?.filename ?? '' };
        }
        // if (resp?.$response?.httpResponse?.statusCode === 200) {
        //   const link = `${process.env.REACT_APP_IMAGE_URL}/${myFilename}`;
        //   return { link: link, name: myFilename };
        // }
      }
    } catch (error) {
      console.error('File upload failed:', error);
    }
    return { link: '', name: '' };
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateFormData(formData);
    if (Object.keys(error).length > 0) return;
    // const currentEntity = selectedNestedParentEntity[entityRowData?.parentEntityForm?._id] ?? null;
    const payload: Record<string, any> = {
      // entity_form: entityRowData?.entity_form || entityFormId,
      entity_form_id: entityFormId,
      // parentEntity: { _id: currentEntity?._id },
      entity: {},
    };

    const toPhoneInt = (val: any): number | undefined => {
      const digits = String(val ?? '').replace(/\D+/g, '');
      return digits ? Number(digits) : undefined;
    };

    try {
      for (const item of formData) {
        if (['image', 'video', 'document'].includes(item.type)) {
          if (item.fileObj) {
            const obj: any = await uploadFile(item.fileObj);
            payload.entity[item.name] = obj?.link ?? ''; //{ type: item.type, url: obj?.link, name: obj?.name || '' };
          } else if (item.value) {
            payload.entity[item.name] = item.value ?? '';
          } else if (entityRowData?.entity?.[item.name]) {
            payload.entity[item.name] = entityRowData?.entity?.[item.name] || {};
          } else {
            delete payload.entity[item.name];
          }
        } else if (item.type === 'phone') {
          const n = toPhoneInt(item.value);
          payload.entity[item.name] = n !== undefined ? n : '';
        } else {
          payload.entity[item.name] = item.value || '';
        }
      }

      const res =
        uuid === 'create'
          ? await actions.createEntity(payload)
          : await actions.updateDetails(entityId, payload);

      if (res?.status === 200) {
        showSnackBar(
          `Entity ${uuid === 'create' ? 'Created' : 'Updated'} successfully!`,
          'success'
        );
        navigate(-1);
      } else {
        showSnackBar('Error!', 'error');
      }
    } catch (error) {
      showSnackBar('Error!', 'error');
    }
  };

  // Fetches the main entity form by ID
  const getEntityFormById = async () => {
    try {
      let res = await actions.getFormById(entityFormId);
      if (res?.status === 200 && res?.data?.items) {
        setEntityRowData(res?.data?.items);
        const fields = res?.data?.items?.form_fields ?? [];
        // fetchAllParentEntitiesForm(res.data.items[0]);
        if (uuid === 'create') {
          setFormData(fields);
          return;
        } else {
          const populatedFields = fields.map((field) => ({
            ...field,
            value: state?.row?.entity?.[field.name] ?? '',
          }));
          setFormData(populatedFields);
        }
      }
    } catch (error) {
      console.warn(error);
    }
  };

  // const fetchAllParentEntitiesForm = async (entityFormObj: any) => {
  //     const parents: any[] = [];
  //     let current = entityFormObj;
  //     while (current?.parentEntityForm?._id) {
  //         try {
  //             const parentRes = await actions.getFormById(current.parentEntityForm._id);
  //             if (parentRes?.status === 200 && parentRes?.data?.items?.length) {
  //                 const parentItem = parentRes.data.items[0];
  //                 parents.push(parentItem);
  //                 current = parentItem;
  //             } else {
  //                 break;
  //             }
  //         } catch (err) {
  //             console.warn("Error fetching parent entity form:", err);
  //             break;
  //         }
  //     }
  //     setNestedEntityDataDropdown(parents.reverse());
  // };
  // const fetchAllParentEntityData = async (entityDataObj) => {
  //     let entityData = {};
  //     let current = entityDataObj;
  //     while (current?.parentEntity?._id) {
  //         try {
  //             const parentRes = await actions.getEntityDataById(current?.parentEntity?._id);
  //             if (parentRes && parentRes?.data?.data && parentRes?.status === 200) {
  //                 entityData = { ...entityData, [parentRes?.data?.data?.entity_form_id]: parentRes?.data?.data };
  //                 const parentItem = parentRes?.data?.data;
  //                 current = parentItem;
  //             } else {
  //                 break;
  //             }
  //         } catch (err) {
  //             console.warn("Error fetching parent entity form:", err);
  //             break;
  //         }
  //     }
  //     setSelectedNestedParentEntity(entityData);
  // };

  // const getChildEntityIds = (parentId) => {
  //     let children = [];

  //     const traverse = (currentParentId) => {
  //         nestedEntityDataDropdown.forEach((form) => {
  //             if (form?.parentEntityForm?._id === currentParentId) {
  //                 children.push(form._id);
  //                 traverse(form._id); // recursive call to go deeper
  //             }
  //         });
  //     };

  //     traverse(parentId);
  //     return [...new Set(children)]; // unique IDs
  // };
  // const handleSelectEntityData = (value, entityFormId) => {
  //     setSelectedNestedParentEntity((prev) => {
  //         const updated = {
  //             ...prev,
  //             [entityFormId]: value?._id ? { _id: value?._id, entity: value?.entity } : null,
  //         };
  //         const childrenToRemove = getChildEntityIds(entityFormId);
  //         childrenToRemove.forEach((childId) => {
  //             delete updated[childId];
  //         });
  //         return updated;
  //     });
  // };

  useEffect(() => {
    const loadFormData = async () => {
      getEntityFormById();
      // if (state?.row) {
      //     fetchAllParentEntityData(state?.row)
      // }
    };
    loadFormData();
  }, [uuid, state?.row]);

  const getFileNameFromUrl = (url) => {
    try {
      const fileName = url?.split('/')?.pop() ?? '';
      return fileName;
    } catch (err) {
      return '';
    }
  };
  return (
    <Box sx={{ width: '100%', minHeight: '90vh', backgroundColor: '#fff', padding: '15px' }}>
      <Box sx={{ flexGrow: 1, marginBottom: '10px' }}>
        <AppBar
          sx={{ backgroundColor: 'transparent', color: 'grey', boxShadow: 'none !important' }}
          position="static"
        >
          <Toolbar>
            <Typography color="Black" variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {entityRowData?.name || ''} Form
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button onClick={() => navigate(-1)} size="small" variant="contained" color="primary">
                Back
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: '2px' }}>
        {/* {nestedEntityDataDropdown?.length > 0 && nestedEntityDataDropdown?.map((item: any, index: number) => (
                    <EntityDetailsDropdown
                        key={index}
                        label={`Select ${item?.name} `}
                        entityFormId={item?._id ?? null}
                        parentEntityId={selectedNestedParentEntity[item?.parentEntityForm?._id]?._id ?? null}
                        selectedEntityFields={[]}
                        displayField={item?.form_fields?.find((field: any) => field.isDefaultDisplay)?.name}
                        value={selectedNestedParentEntity[item?._id] ?? null}
                        onChange={(value: any) => {
                            handleSelectEntityData(value, item?._id);
                        }}
                        sx={{ mb: 2, width: '100%' }}
                    />
                ))} */}
        {Object?.keys(formData)?.length > 0 && (
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ '& .MuiTextField-root': { mb: 3, width: '100%' } }}
          >
            {formData?.map((field: any, index: Number) => {
              if (uuid === 'create' && index === 0) return null;
              const shouldDisable = uuid !== 'create' && index === 0;

              switch (field.type) {
                case 'text':
                case 'number':
                case 'email':
                  return (
                    <TextField
                      key={field?.name}
                      name={field?.name || 'Text'}
                      label={field?.label || 'Input'}
                      type={field?.type}
                      placeholder={field?.placeholder || ''}
                      value={field?.value || ''}
                      onChange={(e: any) => {
                        handleChange(e, index, field);
                      }}
                      required={field?.isRequired}
                      error={errors[field?.name]}
                      helperText={errors[field?.name] ? errors[field?.name] : ''}
                      variant="outlined"
                      disabled={shouldDisable}
                      fullWidth
                      sx={{ mb: 2 }}
                      size="small"
                    />
                  );
                case 'phone':
                  return (
                    <>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={12}>
                          <TextField
                            key={field?.name}
                            label="Phone Number"
                            placeholder={field?.placeholder || ''}
                            value={field?.value}
                            onChange={(e: any) => {
                              handleChange(e, index, field);
                            }}
                            error={errors[field?.name]}
                            helperText={errors[field?.name] ? errors[field?.name] : ''}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIcon />
                                </InputAdornment>
                              ),
                            }}
                            required={field?.isRequired}
                            variant="outlined"
                            fullWidth
                            sx={{ mb: 2 }}
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    </>
                  );

                case 'textArea':
                  return (
                    <>
                      <TextField
                        id={`text-area${field?.name}`}
                        name={field?.name || 'TextArea'}
                        label={field?.label || 'Input'}
                        placeholder={field?.placeholder || ''}
                        multiline
                        rows={3}
                        value={field?.value || ''}
                        onChange={(e: any) => {
                          handleChange(e, index, field);
                        }}
                        required={field?.isRequired}
                        variant="outlined"
                        fullWidth
                        size="small"
                        InputProps={{
                          inputProps: {
                            minLength: 0, // Minimum length constraint
                            // maxLength: 500,
                          },
                        }}
                        sx={{
                          mb: 2,
                          '& .MuiInputBase-root': {
                            padding: 0,
                          },
                          '& textarea': {
                            resize: 'both', // right-bottom resize handle
                            overflow: 'auto',
                          },
                        }}
                        // sx={{ mb: 2 }}
                      />
                      {/* <FormHelperText>Max length 2000.</FormHelperText> */}
                    </>
                  );
                case 'password':
                  return (
                    <FormControl
                      key={field.name}
                      required={field?.isRequired}
                      variant="outlined"
                      sx={{ mb: 2, width: '100%' }}
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        {field?.label || 'Password'}
                      </InputLabel>
                      <OutlinedInput
                        id={`${field.name}-outlined-adornment-password`}
                        type={showPassword ? 'text' : 'password'}
                        value={field?.value || ''}
                        onChange={(e: any) => {
                          handleChange(e, index, field);
                        }}
                        placeholder={field?.placeholder || ''}
                        label={field?.label || 'Password'}
                        size="small"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  );
                case 'dropdown':
                  return (
                    <FormControl key={field.name} variant="outlined" sx={{ mb: 2, width: '100%' }}>
                      <InputLabel id={`${field?.name}-label`}>
                        {field.label}
                        {field?.isRequired && ' *'}
                      </InputLabel>
                      <Select
                        labelId={`${field?.name}-label`}
                        id={`${field?.name}-label`}
                        name={field?.name}
                        value={field?.value}
                        onChange={(e: any) => {
                          handleChange(e, index, field);
                        }}
                        label={`${field.label}${field?.isRequired ? ' *' : ''}`}
                        required={field?.isRequired}
                        size="small"
                      >
                        {field?.options?.map((option: any) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                case 'radio':
                  return (
                    <FormControl key={field.name} variant="outlined" sx={{ mb: 2, width: '100%' }}>
                      <FormLabel component="legend">
                        {field?.label}
                        {field?.isRequired && ' *'}
                      </FormLabel>
                      <RadioGroup
                        name={field?.name}
                        value={field?.value || ''}
                        onChange={(e: any) => {
                          handleChange(e, index, field);
                        }}
                        row
                      >
                        {field?.options?.map((option: any) => (
                          <FormControlLabel
                            key={option}
                            value={option}
                            control={<Radio required={field?.isRequired} />}
                            label={option}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  );
                case 'checkbox':
                  return (
                    <FormControl
                      key={field?.name}
                      required={field?.isRequired}
                      variant="outlined"
                      sx={{ mb: 2, width: '100%' }}
                    >
                      <FormLabel component="legend">{field?.label}</FormLabel>
                      {field?.options?.map((option: any) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              name={field?.name}
                              value={option}
                              checked={field?.value?.includes(option)}
                              onChange={(e: any) => {
                                handleChange(e, index, field);
                              }}
                            />
                          }
                          label={option}
                        />
                      ))}
                      {field?.isRequired && (
                        <FormHelperText>Please select at least one option.</FormHelperText>
                      )}
                    </FormControl>
                  );
                case 'date':
                  return (
                    <>
                      <TextField
                        key={field?.name}
                        id={field?.name}
                        name={field?.name || 'Date'}
                        label={field?.label || 'Select'}
                        type={'date'}
                        placeholder={field?.placeholder || 'Select Date'}
                        value={field?.value}
                        onChange={(e: any) => {
                          handleChange(e, index, field);
                        }}
                        // onClick={(event: any) => { event.target.value = null }}
                        required={field?.isRequired}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={{ mb: 2 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </>
                  );
                case 'image':
                case 'document':
                case 'video':
                  return (
                    <Box key={field?.name} sx={{ mb: 2 }}>
                      {/* <Typography variant="body2">
                      {field.label} {field?.isRequired && '*'}
                    </Typography> */}
                      <FormControlLabel
                        control={
                          <Switch
                            checked={showHideFileUpload[field?.name] ?? false}
                            onChange={(e) => {
                              setShowHideFileUpload((prevItems: any) => {
                                const updatedItems = { ...prevItems };
                                updatedItems[field?.name] = e.target.checked;
                                return updatedItems;
                              });
                            }}
                            inputProps={{ 'aria-label': 'controlled' }}
                            size="small"
                          />
                        }
                        label={`Upload ${field?.type ?? ''}`}
                      />
                      {/* File preview if exists */}
                      {!showHideFileUpload[field?.name] && (
                        <TextField
                          id={`${field?.name}-link`}
                          name={`${field?.name}-link`}
                          type="url"
                          label={`Paste a direct ${field?.type ?? ''} link`}
                          value={field?.value ?? ''}
                          onChange={(e: any) => handleChange(e, index, field)}
                          variant="outlined"
                          fullWidth
                          size="small"
                          sx={{ mt: 1 }}
                          required={field?.isRequired ?? false}
                          InputProps={{
                            endAdornment: (
                              <IconButton
                                edge="end"
                                onClick={async () => {
                                  try {
                                    const url = await navigator.clipboard.readText();
                                    const fileName = url?.split('/')?.pop() ?? '';
                                    setFormData((prevItems: any) => {
                                      const updatedItems = [...prevItems];
                                      updatedItems[index] = {
                                        ...updatedItems[index],
                                        fileObj: null,
                                        value: url ?? '', //{ type: field?.type, url: text, name: fileName },
                                      };
                                      return updatedItems;
                                    });
                                  } catch (err) {
                                    console.error('Clipboard read failed', err);
                                  }
                                }}
                              >
                                <ContentPasteIcon />
                              </IconButton>
                            ),
                          }}
                        />
                      )}

                      {showHideFileUpload[field?.name] && (
                        <>
                          {field?.value && field?.value && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                              <Typography variant="body2" color="primary">
                                <a
                                  href={field?.value ?? ''}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {getFileNameFromUrl(field?.value) ?? ''}
                                </a>
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setFormData((prevItems: any) => {
                                    const updatedItems = [...prevItems];
                                    updatedItems[index] = {
                                      ...updatedItems[index],
                                      fileObj: null,
                                      value: '',
                                    };
                                    return updatedItems;
                                  });

                                  setErrors((prevErrors) => {
                                    const newErrors = { ...prevErrors };
                                    delete newErrors[field?.name];
                                    return newErrors;
                                  });
                                }}
                              >
                                <ClearIcon fontSize="small" color="black" />
                              </IconButton>
                            </Box>
                          )}
                          <TextField
                            id={`${field?.name}-file`}
                            name={`${field?.name}-file`}
                            type="file"
                            onChange={(e: any) => handleChange(e, index, field, 'file')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            required={field?.isRequired ?? false}
                            error={!!errors[field?.name]}
                            helperText={errors[field?.name] ? errors[field?.name] : ''}
                            InputLabelProps={{ shrink: true }}
                          />
                        </>
                      )}
                      <FormHelperText sx={{ mt: 0 }}>
                        {fileHelperTextMap[field?.type ?? ''] ?? ''}
                      </FormHelperText>
                    </Box>
                  );
                default:
                  return null;
              }
            })}
            <Button
              type="submit"
              size="small"
              variant="contained"
              color="primary"
              sx={{ width: '100%' }}
            >
              Submit
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default CreateEditFormData;
